import { DepositDialog } from '@bz/wallet';

export const route: RouteDefinition = {
  preload: () => {
    // return get.getMarketTypeList({sportType: Number(params.sportType)});
  },
  info: {
    login: true,
    dialog: {
      get title() {
        return t('Deposit');
      },
      class: 'w-[480px] h-[700px] [&>.dialog-wrap>.dialog-title]:!bg-layer5',
    },
  },
};

export default DepositDialog;
